module.exports = __webpack_public_path__ + "img/mini-progran-or-code.2d3127a9.jpg";